import { DatabaseTagsModel } from "@models/database-tags.model";
import { createAction, props } from "@ngrx/store";

export const resetToInitialState = createAction('[ENTITY TAG] Reset to Initial state');

export const startLoadingEntitiesByTag = createAction('[ENTITY TAG] Start Loading Entities By Tag', props<{id: string, entityTypesFilter?: DatabaseTagsModel.EntityType[]}>());

export const getEntitiesByTag = createAction('[ENTITY TAG] Get Entities By Tag', props<{id: string, entityTypesFilter?: DatabaseTagsModel.EntityType[]}>());
export const getEntitiesByTagSuccess = createAction('[ENTITY TAG] Get Entities By Tag Success', props<{ entitiesByTag: DatabaseTagsModel.EntityTagDocument[] }>());
export const getEntitiesByTagFail = createAction('[ENTITY TAG] Get Entities By Tag Fail');

export const setIsLoading = createAction('[ENTITY TAG] Set Is Entities Loading', props<{ isLoading: boolean }>());
export const resetList = createAction('[ENTITY TAG] Reset List');

export const startSettingEntityTypesFilter = createAction('[ENTITY TAG] Start Setting Entity Types Filter', props<{ entityTypesFilter: DatabaseTagsModel.EntityType[], id: string}>());